var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isProvided)?_c('dynamic-rate',[_c('rate',{attrs:{"is-available":_vm.isAvailable,"value":_vm.formattedValue,"is-selected":_vm.isSelected,"toggle":_vm.toggleRate}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }